import React, { useState, useEffect } from "react";
import "./contact.css";
import { useSelector } from "react-redux";
import { getEmail, getName } from "./../../features/userSlice";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";
import firebase, { db } from "./../firebase";
import { useHistory } from "react-router-dom";
function Contact() {
  const email = useSelector(getEmail);
  const name = useSelector(getName);
  const [msgBody, setmsgBody] = useState("");
  const [msgSub, setmsgSub] = useState("");
  const [mob, setmob] = useState("none");
  let history = useHistory();
  useEffect(() => {
    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {
        window.alert("Login First");
        history.goBack();
      }
    });
  }, []);
  const handleSubmit = () => {
    if (name === "" || msgSub === "" || msgBody === "")
      window.alert("Fill All the Fields");
    else {
      const docRef = db.collection("Contact-Forms").doc();
      docRef
        .set({
          email: email,
          name: name,
          subject: msgSub,
          body: msgBody,
          mobile: mob,
          date: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(window.alert("sent"))
        .catch((err) => console.log(err));
    }
  };
  return email ? (
    <div className="contact">
      <div className="smaller">
        <div className="emailFeild">
          <TextField
            disabled
            className="textfeild"
            id="filled-basic"
            fullWidth
            variant="filled"
            label="Email"
            defaultValue={email}
          />
        </div>
        <div className="nameFeild">
          <TextField
            required
            id="outlined-basic"
            label="Name"
            style={{ color: "whitesmoke" }}
            variant="outlined"
            fullWidth
            className="textfeild"
            defaultValue={name}
          />
        </div>
        <div className="msgSubject">
          <TextField
            required
            id="filled-basic"
            className="textfeild"
            fullWidth
            variant="outlined"
            color="white"
            onChange={(e) => setmsgSub(e.target.value)}
            label="Subject"
          />
        </div>
        <div className="msgSubject">
          <TextField
            id="filled-basic"
            className="textfeild"
            fullWidth
            variant="outlined"
            color="white"
            placeholder="Optional"
            onChange={(e) => setmob(e.target.value)}
            label="Mobile Number"
          />
        </div>
        <div className="msgBody">
          <TextField
            required
            id="filled-multiline-static"
            variant="outlined"
            fullWidth
            onChange={(e) => setmsgBody(e.target.value)}
            label="Message Body"
            multiline
            rows={5}
          />
        </div>
        <Button
          className="m-3 align-self-center"
          color="primary"
          variant="contained"
          endIcon={<SendIcon />}
          onClick={handleSubmit}
        >
          {" "}
          Send Message
        </Button>
      </div>
    </div>
  ) : (
    <>
      {/* <div className="contact-login">
      {" "}
      <div className="temp">
        <p>Login First</p>
      </div>{" "}
    </div> */}
    </>
  );
}

export default Contact;
